<template>
  <div class="videoPlayer">
    <!-- 视频播放器容器 -->
    <video id="videoElement" width="100%" height="100%" controls muted></video>
  </div>
</template>

<script>
import flvjs from "flv.js";

export default {
  name: "FlvPlayer",
  data() {
    return {
      flvPlayer: null,
      videoElement: null,
      loaded: !1,
      playing: !1,
    };
  },
  created() {
    //添加自定义事件，启动播放，停止播放
    window.startVideoPlay = this.startVideoPlay;
    window.stopVideoPlay = this.stopVideoPlay;
  },
  methods: {
    stopVideoPlay() {
      this.flvPlayer &&
        (this.unload(),
        (this.videoElement = null),
        this.flvPlayer.detachMediaElement(),
        this.flvPlayer.destroy(),
        (this.flvPlayer = null));
    },
    unload() {
      (this.loaded = !1),
        this.flvPlayer.pause(),
        this.flvPlayer.unload(),
        (this.playing = !1);
    },
    startVideoPlay(url) {
      if (flvjs.isSupported()) {
        // 获取视频元素
        this.videoElement = document.getElementById("videoElement");
        // 创建 flv 播放器实例
        this.flvPlayer = flvjs.createPlayer({
          type: "flv",
          url: url, // 替换为实际的 FLV 视频 URL
        });
        // 将 flv 播放器绑定到视频元素
        this.flvPlayer.attachMediaElement(this.videoElement);
        // 加载视频
        this.flvPlayer.load();
        // 播放视频
        this.flvPlayer.play();
      }
    },
  },
  mounted() {

    this.startVideoPlay('https://www.kingwings.cn:7205/live/00140401000001.live.flv');
  },
};
</script>

<style scoped>
.videoPlayer {
  overflow: hidden;
  clear: both;
  width: 100%;
  height: calc(100% - 0px);
  position: relative;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}

.videoPlayer > video {
  position: relative;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  -o-object-fit: fill;
  object-fit: fill;
}
</style>
